function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
// GENERATED BY ./scripts/generate.ts
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import ElevenLabsFilledSvg from '@ant-design/icons-svg/lib/asn/ElevenLabsFilled';
import AntdIcon from "../components/AntdIconLight";
const ElevenLabsFilled = (props, ref) => /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
  ref: ref,
  icon: ElevenLabsFilledSvg
}));

/**![eleven-labs](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTAiIGhlaWdodD0iNTAiIGZpbGw9IiNjYWNhY2EiIHZpZXdCb3g9IjY0IDY0IDg5NiA4OTYiIGZvY3VzYWJsZT0iZmFsc2UiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZD0iTTIzNS44NiA2NHY4OTZoMTg0LjEyVjY0em0zNjguMTYgMHY4OTZoMTg0LjEyVjY0eiIgLz48L3N2Zz4=) */
const RefIcon = /*#__PURE__*/React.forwardRef(ElevenLabsFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ElevenLabsFilled';
}
export default RefIcon;